import React from 'react';
import {Button, Col, Form, Row} from 'antd';
import {withRouter} from 'react-router-dom';
import {ClientBase} from "./ClientBase";

class ClientsManagementBar extends ClientBase {

    customButtons(key) {
        return <Row>
            <Col lg={{span: 5}} sm={{span: 8}} className="padding-right padding-top-right">
                <Button key="clientsAddBtn" icon="plus" block={true}
                        type="primary"
                        onClick={(e) => {
                            this.showDrawer()
                        }}>
                    {'Adicionar'}
                </Button>
            </Col>
            <Col lg={{span: 5}} sm={{span: 8}} className="padding-right padding-top-right">
                <Button key="clientsAddBtn" icon="ordered-list" block={true}
                        type="danger" className="mrg-right"
                        onClick={(e) => {
                            this.props.history.push('/server/connection-history');
                        }}>
                    {'Historial de conexión'}
                </Button>
            </Col>
            <Col lg={{span: 5}} sm={{span: 8}} className="padding-right padding-top-right">
                <Button key="clientsAddBtn" icon="api" block={true}
                        type="default" className="mrg-right"
                        onClick={(e) => {
                            this.props.history.push('/server/socket-sessions');
                        }}>
                    {'Sockets'}
                </Button>
            </Col>
        </Row>
    }
}

const ClientsManagementBarButtons = Form.create()(withRouter(ClientsManagementBar));
export default ClientsManagementBarButtons;


// WEBPACK FOOTER //
// ./src/app/views/clients/ClientsManagementBar.js